import httpRequest from '../../common/lib/http-request';

// *************************
// FINANCIAL SERVICES
// *************************

function getAssociateData(registrationRef) {
    return httpRequest({
        url: '/Registration/associate/' + registrationRef,
        method: 'GET'
    }, false, process.env.REACT_APP_CORE_API_URL);
}

function getInternalAssociateData(userRef) {
    return httpRequest({
        url: '/Associate/internal/' + userRef,
        method: 'GET'
    }, false, process.env.REACT_APP_CORE_API_URL);
}

function updateAssociateData(associate, action, updatedAreas) {
    return httpRequest({
        url: '/Associate',
        method: 'PUT',
        data: {
            associate: associate,
            author: 'Associate',
            action: action,
            updatedAreas: [ updatedAreas ]  
        }
    }, false, process.env.REACT_APP_CORE_API_URL);
}

function getAssociateActionLog(associateId) {
    return httpRequest({
        url: '/Associate/action-log/' + associateId,
        method: 'GET'
    }, false, process.env.REACT_APP_CORE_API_URL);
}

function uploadAssociateDocument(fileContent, registrationRef, documentType) {
    return httpRequest({
        url: '/Associate/document/upload',
        method: 'POST',
        data: {
            fileContent: fileContent,
            registrationReference: registrationRef,
            documentType: documentType
        }
    }, false, process.env.REACT_APP_CORE_API_URL);
}

const ProfileService = { getAssociateData, getInternalAssociateData, updateAssociateData, getAssociateActionLog, uploadAssociateDocument }

export default ProfileService;